export const BASENAME = '/dp-air';

export const STATIC_DPP_TOP_URL = 'https://www.nta.co.jp';

export const STORAGE_EXPIRATION_MILI_SECOND = 30 * 60 * 1000;

export const LAYOUT_TYPES = {
  default: 'DEFAULT',
  seat: 'SEAT',
  step: 'STEP',
  error: 'ERROR',
};

export const AIRLINES = {
  ana: 'Ana',
  jal: 'Jal',
};

export const AIRLINES_QUERY_PARAMS_MAP = {
  ANA: AIRLINES.ana,
  JAL: AIRLINES.jal,
};

export const BOOKING_CLASS_CLASS_J = 'J';

export const SORT_ORDERS = {
  popularity: 'Popularity',
  priceAsc: 'PriceAsc',
  priceDesc: 'PriceDesc',
};

export const SORT_ORDERS_QUERY_PARAMS_MAP = {
  Popularity: SORT_ORDERS.popularity,
  PriceAsc: SORT_ORDERS.priceAsc,
  PriceDesc: SORT_ORDERS.priceDesc,
};

export const ROOM_TYPES = {
  japanese: 'JAPANESE',
  westernAndJapanese: 'WESTERN_AND_JAPANESE',
  single: 'SINGLE',
  doubleAndSemidouble: 'DOUBLE_AND_SEMIDOUBLE',
  twin: 'TWIN',
  triple: 'TRIPLE',
  other: 'OTHER',
  none: 'NONE',
  double: 'DOUBLE',
  semidouble: 'SEMIDOUBLE',
  bed4: 'BED_4',
};

export const ROOM_TYPES_QUERY_PARAMS_MAP = {
  1: ROOM_TYPES.japanese,
  2: ROOM_TYPES.westernAndJapanese,
  4: ROOM_TYPES.single,
  5: ROOM_TYPES.doubleAndSemidouble,
  6: ROOM_TYPES.twin,
  7: ROOM_TYPES.triple,
  8: ROOM_TYPES.other,
  9: ROOM_TYPES.none,
  10: ROOM_TYPES.double,
  11: ROOM_TYPES.semidouble,
  12: ROOM_TYPES.bed4,
};

export const MEAL_CONDITIONS = {
  unspecified: 'UNSPECIFIED',
  none: 'NONE',
  rcType: 'R_C_TYPE',
  breakfast: 'BREAKFAST',
  dinner: 'DINNER',
  breakfastAndDinner: 'BREAKFAST_AND_DINNER',
};

export const MEAL_CONDITIONS_QUERY_PARAMS_MAP = {
  1: MEAL_CONDITIONS.none,
  2: MEAL_CONDITIONS.rcType,
  3: MEAL_CONDITIONS.breakfast,
  4: MEAL_CONDITIONS.dinner,
  5: MEAL_CONDITIONS.breakfastAndDinner,
};

export const TAG_IDS_MAP = {
  hotel: '1',
  ryokan: '2',
  naturalSpa: '3',
  walk5: '4',
  openAirBath: '5',
  bigBath: '6',
  transportation: '7',
  singleRyokan: '8',
  nonSmokingRoom: '9',
  smokingRoom: '10',
  openAirBathRoom: '11',
  earlyApplication: '12',
  privateDinner: '13',
  roomDinner: '14',
};

export const PLAN_LIST_HIDE_TAGS = [
  '施設のタイプ',
  '施設の特徴',
  '温泉・お風呂',
  '施設設備(プール)',
  '施設設備(その他)',
  'サービス',
  '施設の評価',
  '施設・設備',
];

export const RELATIONSHIP_OPTIONS = [
  { id: 'FATHER', name: '父', value: 'FATHER' },
  { id: 'MOTHER', name: '母', value: 'MOTHER' },
  { id: 'OLD_BLOTHER', name: '兄', value: 'OLD_BLOTHER' },
  { id: 'OLD_DAUGHTER', name: '姉', value: 'OLD_DAUGHTER' },
  { id: 'YOUNG_BLOTHER', name: '弟', value: 'YOUNG_BLOTHER' },
  { id: 'YOUNG_DAUGHTER', name: '妹', value: 'YOUNG_DAUGHTER' },
  { id: 'GRAND_FATHER', name: '祖父', value: 'GRAND_FATHER' },
  { id: 'GRAND_MOTHER', name: '祖母', value: 'GRAND_MOTHER' },
  { id: 'UNCLE', name: '叔父', value: 'UNCLE' },
  { id: 'AUNT', name: '叔母', value: 'AUNT' },
  { id: 'COUSIN', name: '従兄弟', value: 'COUSIN' },
  { id: 'RELATIVES', name: '親戚', value: 'RELATIVES' },
  { id: 'FRIENDS', name: '友人', value: 'FRIENDS' },
  { id: 'WORKPLACE', name: '勤務先', value: 'WORKPLACE' },
  { id: 'HOUSEMATE', name: '同居人', value: 'HOUSEMATE' },
  { id: 'SON', name: '息子', value: 'SON' },
  { id: 'DAUGHTER', name: '娘', value: 'DAUGHTER' },
  { id: 'HUSBAND', name: '夫', value: 'HUSBAND' },
  { id: 'WIFE', name: '妻', value: 'WIFE' },
  { id: 'GRANDCHILD', name: '孫', value: 'GRANDCHILD' },
  { id: 'STEPFATHER', name: '義父', value: 'STEPFATHER' },
  { id: 'STEPMOTHER', name: '義母', value: 'STEPMOTHER' },
];

export const COUPON_TYPES = {
  coupon: 'COUPON',
  discount: 'DISCOUNT',
};

export const CHARGE_KIND = {
  adult: 'ADULT',
  childrenA: 'CHILDRENA',
  childrenB: 'CHILDRENB',
  childrenC: 'CHILDRENC',
  children2: 'CHILDREN2',
  infant: 'INFANT',
};

export const CHARGE_KIND_DISPLAY = {
  ADULT: '大人',
  CHILDRENA: 'こども(6〜11歳)',
  CHILDRENB: 'こども(3〜5歳)(寝具あり)',
  CHILDRENC: 'こども(3〜5歳)(寝具なし)',
  CHILDREN2: 'こども(2歳)',
  INFANT: 'こども(0〜1歳)',
};

export const PLAN_OPTION_CHARGE_KIND = [
  { id: 'SN', name: 'シニア', kind: 'adult', kindName: '大人', flightAndPlan: '座席あり/寝具あり', isAdult: true },
  { id: 'AD', name: 'おとな', kind: 'adult', kindName: '大人', flightAndPlan: '座席あり/寝具あり', isAdult: true },
  { id: 'OT', name: '大学生', kind: 'adult', kindName: '大人', flightAndPlan: '座席あり/寝具あり', isAdult: true },
  { id: 'ZP', name: '高校生', kind: 'adult', kindName: '大人', flightAndPlan: '座席あり/寝具あり', isAdult: true },
  { id: 'MD', name: '中学生', kind: 'adult', kindName: '大人', flightAndPlan: '座席あり/寝具あり', isAdult: true },
  { id: 'CA', name: '小学生', kind: 'childrenA', kindName: 'こども(6〜11歳)', flightAndPlan: '座席あり/寝具あり', isAdult: false },
  { id: 'CB', name: '小児', kind: 'childrenB', kindName: 'こども(3〜5歳)', flightAndPlan: '座席あり/寝具あり', isAdult: false },
  { id: 'CC', name: '幼児', kind: 'childrenC', kindName: 'こども(3〜5歳)', flightAndPlan: '座席あり/寝具なし', isAdult: false },
  { id: 'C2', name: '幼児', kind: 'children2', kindName: 'こども(2歳)', flightAndPlan: '座席あり/寝具なし', isAdult: false },
  { id: 'IF', name: '乳児', kind: 'infant', kindName: 'こども(0〜1歳)', flightAndPlan: '座席なし/寝具なし', isAdult: false },
];

export const DEFAULT_CHECKIN_TIME = '18:00';

export const UNEXPECTED_ERROR_MESSAGE = '予期せぬエラーが発生しました。';

export const ERROR_CLASSNAME_INPUT = 'hasError';

export const SHOWING_HOTEL_LIMIT = 10;

export const SHOWING_PLAN_LIMIT = 3;

export const UNSELECTED_LABEL = '指定なし';

export const ERROR_STATUS_MESSAGE_MAP = {
  Y10: '既に在庫がありませんでした。（Y10)',
  Y11: 'ご希望の宿泊日は予約できません。お手数ですがはじめからやり直してください。（Y11)',
  Y12: 'システムメンテナンス中です。（Y12)',
  Y13: 'すでに予約はキャンセルされています。（Y13)',
  Y14: '旅行代金が更新されました。お手数ですが、再度旅行代金をご確認の上、お申込みください。（Y14)',
  Y15: 'システムメンテナンス中です。（Y15)',
  Y16: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y16)',
  Y17: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y17)',
  Y18: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y18)',
  Y19: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y19)',
  Y20: '登録済みです。（Y20）',
  Y90: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y90)',
  Y91: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y91)',
  Y92: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y92)',
  Y93: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y93)',
  Y94: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y94)',
  Y95: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y95)',
  Y96: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。（Y96)',
  Y21: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。(Y21)',
  Y22: 'ただいま大変込み合っております。お手数ですが、しばらくしてからもう一度やり直してください。(Y22)',
  Y97: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。(Y97)',
  Y98: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。(Y98)',
  Y23: '現在WESTERサービスメンテナンス中のためご予約できません。誠に申し訳ございませんが、WESTERサービスメンテナンス後に再度操作をお願い致します。(Y23)',
  Y24: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。(Y24)',
  Y25: 'お客様ご指定の条件ではご予約いただけません。お手数ですが日付・施設等を変えてやり直してください。(Y25)',
  // fallback
  fallback:'システムで障害が発生しました。お手数ですがはじめからやり直してください。',
};

export const TIMEOUT_ERROR_CODE = 'T01';

export const DEFAULT_UNSELECETD_LABEL = '-';

export const ENABLE_MULTIPLE_HOTEL_PLAN = false;

export const ENABLE_GOTO_AGREEMENT_FEATURE = false;

export const ENABLE_GIFT_CARD_FEATURE = true;

export const ENABLE_CHANGE_STAY_NIGHTS_FEATURE = true;

export const STOP_BOOKING_FEATURE_PERIODS_DATE_FORMAT = 'YYYYMMDD-HHmmss';

export const ENABLE_STOP_BOOKING_FEATURE_PERIODS = [
  // 'YYYYMMDD-HHmmss'
  { from: '20251225-000000', to: '20260105-095959' },
];

export const UNAVAILABLE_CALENDAR_DATE = [
  // 'YYYYMMDD'
  '20251225',
  '20251226',
  '20251227',
  '20251228',
  '20251229',
  '20251230',
  '20251231',
  '20260101',
  '20260102',
  '20260103',
  '20260104',
  '20260105'
];

